<script setup>
import {APP_STORE} from '~/utils/appLinks';
import {useCookieConsent} from "~/composables/useCookieConsent";
import {useNavigationItems} from "~/composables/useNavigationItems";

const {openSettings} = useCookieConsent();

const config = useRuntimeConfig();
const appName = config.public.appName;

const {mainMenuItems} = useNavigationItems();

const year = new Date().getFullYear();
</script>

<template>
  <div class="w-100">
    <v-row>
      <v-col cols="12" sm="5">
        <router-link to="/" tag="span" style="cursor: pointer">
          <nuxt-img :alt="appName" class="logo mb-4" format="webp" contain src="/images/logo_thin.png" width="325" height="150"/>
        </router-link>
        <p class="text-charcoal footer-tagline mb-4">
          Competitions, memberships and bookings for your club. Any sport, one place, on the web and in the app.
        </p>
        <div class="d-flex flex-row ga-2">
          <a :href="APP_STORE.ios" target="_blank">
            <nuxt-img :alt="appName" contain src="/images/apple_link.png" width="120"/>
          </a>
          <a :href="APP_STORE.android"
             target="_blank">
            <nuxt-img :alt="appName" contain src="/images/google_link.png" width="128"/>
          </a>
        </div>
      </v-col>
      <v-col cols="12" sm="4">
        <div class="tl-label mb-3">Explore</div>
        <NuxtLink v-for="item in mainMenuItems" :key="item.title" :to="item.link" class="footer-link">
          {{ item.title }}
        </NuxtLink>
      </v-col>
      <v-col cols="12" sm="3">
        <div class="tl-label mb-3">More</div>
        <NuxtLink to="/legal/terms" class="footer-link">Terms of use</NuxtLink>
        <NuxtLink to="/legal/privacy" class="footer-link">Privacy policy</NuxtLink>
        <a href="#" class="footer-link" @click.prevent="openSettings">Cookie settings</a>
      </v-col>
    </v-row>
    <div class="footer-legal d-flex align-center justify-space-between mt-6 pt-4">
      <span class="text-textSubtle footer-copy">© {{ year }} {{ appName }}. All rights reserved.</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.logo {
  width: 120px;
  height: auto;
  display: block;
}

.footer-tagline {
  font-size: 12px;
  line-height: 1.7;
  max-width: 300px;
}

.footer-link {
  display: block;
  font-size: 12.5px;
  font-weight: 500;
  color: rgb(var(--v-theme-charcoal));
  text-decoration: none;
  padding: 5px 0;

  &:hover {
    color: rgb(var(--v-theme-text));
  }
}

.footer-legal {
  border-top: 1px solid rgb(var(--v-theme-borderLight));
}

.footer-copy {
  font-size: 11px;
}
</style>
